export const useTagCountText = (count: number) => {
	if (count === 0) {
		return 'Добавить теги';
	} if (count === 1) {
		return 'Выбран 1 тег';
	} if (count > 1 && count < 5) {
		return `Выбрано ${count} тега`;
	}
	return `Выбрано ${count} тегов`;
};
